import { logger } from '../../../utils/logger'
import { getJsonSessionItem } from '../../../utils/session-storage'
import type { ServiceHandler } from './service-registry'
import { getSessionStorageCustomQuestionsKey } from './setCustomQuestionAnswer'
import type {
  DonorQuestionAnswers,
  GetDonorQuestionAnswersRequest,
  GetDonorQuestionAnswersResponse,
} from '@custom-embedded-code-sdk/methods/donor-questions'

/**
 * GET_CUSTOM_QUESTION_ANSWERS service handler
 *
 * Handles requests to retrieve all Custom Question answers for the current campaign.
 * Retrieves answers from session storage under the key `custom_questions_{campaignId}`.
 */
export const getCustomQuestionAnswers: ServiceHandler<
  GetDonorQuestionAnswersRequest,
  GetDonorQuestionAnswersResponse
> = async ({ iframeId, messageId, sendSuccessResponse, sendErrorResponse, pageConfig }) => {
  const campaignId = pageConfig.campaignId

  try {
    if (!campaignId) {
      throw new Error('CustomEmbeddedCode:getCustomQuestionAnswers: Campaign ID not available')
    }

    const storageKey = getSessionStorageCustomQuestionsKey(campaignId)
    const customQuestionAnswers = getJsonSessionItem<DonorQuestionAnswers>(storageKey) || {}

    logger(
      'info',
      'CustomEmbeddedCode:getCustomQuestionAnswers: Successfully retrieved Custom Question answers',
      {
        context: { iframeId, messageId, campaignId, storageKey },
      },
    )

    sendSuccessResponse(iframeId, messageId, customQuestionAnswers)
  } catch (error) {
    logger(
      'error',
      new Error(
        'CustomEmbeddedCode:getCustomQuestionAnswers: Failed to get Custom Question answers',
        {
          cause: error,
        },
      ),
      {
        context: { iframeId, messageId, campaignId },
      },
    )
    sendErrorResponse(iframeId, messageId, 'Unable to get Custom Question answers')
  }
}
